import {IResponse, IAvailabilityOptions, LocationType, IAvailability} from '@signal/asp-data-commons';
import {Observable, of, throwError} from 'rxjs';
import { countryCd } from '../shared/services/util.service';

/* Projectors */
export function toData<T>(response: IResponse<T>, successCode: number = 200): Observable<T> {
  if (response.status.code === successCode) {
    return of(response.data);
  } else {
    return throwError(`${response.status.code} - ${response.status.messages.join(', ')}`);
  }
}

export function fromAvailabilityOptions(availabilityOptions: IAvailabilityOptions,transportationTypeCode?: string) {
    let transport;
   transport = availabilityOptions.transport.transportOptions
    .filter(t => t.isActive && t.category === LocationType.DEALER)[0]?.id;
  if(transportationTypeCode?.length){
    transport = availabilityOptions.transport.transportOptions
    .filter(t => t.isActive && t.id === transportationTypeCode)[0]?.id;
  }
  const languageId = (countryCd === 'MEX')?'es':'en';
  const advisorId = '-1';
  return {
    transport,
    remoteZipCode : '',
    availability: {
      languageId,
      advisorId,
      fniAdvisorId: '-1',
      appointmentStartDate: '',
      timeSlotId: ''
    } as any
  };
}

export function getDateTime(availability: IAvailability) {
  let appointmentStartDate = '';
  let timeSlotId = '';

  if (availability.suggestedTimes.length) {
    appointmentStartDate = availability.suggestedTimes[0].date;
    timeSlotId = availability.suggestedTimes[0].timeSlots[0]?.timeSlotId || '';
  }

  return {
    appointmentStartDate,
    timeSlotId,
  };
}
